export default __webpack_public_path__ + "static/media/retakeYono.a7cd3c96.png";